import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/monmarche.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";

const Home = () => {
  return (
    <div className="home-container">
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
          Monmarche : Votre marché en ligne, directement à votre porte
          </h1>
          <p className="primary-text">
          "Monmarche" est votre compagnon idéal pour simplifier vos achats alimentaires en Guinée Conakry, 
          et bien plus encore. Avec notre application conviviale, 
          vous pouvez parcourir une large sélection de produits alimentaires frais, 
          de haute qualité et de marques renommées, directement depuis votre téléphone ou votre tablette.
          </p>
          <button className="secondary-button">
            Telecharger Maintenant <FiArrowRight />{" "}
          </button>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Home;
